var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Resolved)?_c(_vm.Resolved,{tag:"component"}):_c('div',{staticClass:"text-center my-3"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }